export enum CondoListViewMode {
    Contain = 'contain',
    Cover = 'cover',
}
